import _ from "lodash";

export const getPaymentErrorMessage = (error: any) => {
  const errorStatusText = _.get(error, "response.statusText");
  return _.get(error, "response.data.error.message", errorStatusText);
};
